import React from "react";
import { caseSizes, caseSizesDefault } from "../../utils/constants";
import IncrDecrInput from "./IncrDecrInput.jsx";

class SetCaseMenuSizeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            caseSize:
                this.props.Dyn.plotView.plotShaper.iconStyler.getIconSize(),
        };
    }

    setCaseIconSize = (m) => {
        let Dyn = this.props.Dyn;
        Dyn.preferences.setCaseIconSize(m);
    };

    updateCaseSize = () => {
        this.setState({
            caseSize:
                this.props.Dyn.plotView.plotShaper.iconStyler.getIconSize(),
        });
    };

    componentDidMount = () => {
        let { Dyn } = this.props;
        Dyn.addSubcribersToClean(
            Dyn.mediator.subscribe("pref:newCaseIconSize", () => {
                this.updateCaseSize();
            })
        );
    };

    static sizeOptions = caseSizes.map( n => ({
        label: n.toString(),
        value: (n==caseSizesDefault)? 0 : n })); // if init with 0, use default size

    render() {
        return (
            <IncrDecrInput
                label={"Case Size"}
                onChange={(caseSize) =>
                    this.setState({ caseSize }, () =>
                        this.setCaseIconSize(caseSize)
                    )
                }
                getLoc={this.props.getLoc}
                value={this.state.caseSize}
                options={SetCaseMenuSizeComponent.sizeOptions}
                className={
                    "tde-mb-3" + this.props.isFromContextMenu
                        ? null
                        : this.props.reduceCaseCardWidth
                        ? " tde-fill"
                        : " tde-col-8"
                }
            ></IncrDecrInput>
        );
    }
}

export default SetCaseMenuSizeComponent;
